import { Component } from '@angular/core'

@Component({
  selector: 'flo-entity-hub-skeleton',
  templateUrl: './entity-hub-skeleton.component.html',
  styleUrls: ['./entity-hub-skeleton.component.scss']
})
export class EntityHubSkeletonComponent {}
